import React, { createContext, useContext, useEffect, useState } from 'react';
import jm from '../api';
import SearchSelect, { employeeOptions } from './SearchSelect';

/**
 * Jobs, employees, departments and shifts are needed by nearly every dialog.
 * Load them once for the whole module rather than per tab.
 */
const EMPTY_MASTERS = {
  jobs: [], employees: [], incharge: [], hods: [], departments: [], shifts: [],
  contractors: [], contractTypes: [], ready: false,
};

const MastersContext = createContext(EMPTY_MASTERS);

export const MastersProvider = ({ children }) => {
  const [masters, setMasters] = useState(EMPTY_MASTERS);

  useEffect(() => {
    let cancelled = false;

    Promise.all([
      jm.jobs().catch(() => []),
      jm.employees().catch(() => ({ employees: [], incharge: [], hods: [] })),
      jm.departments().catch(() => []),
      jm.shifts().catch(() => []),
      jm.contractors().catch(() => []),
      jm.contractTypes().catch(() => []),
    ]).then(([jobs, staff, departments, shifts, contractors, contractTypes]) => {
      if (cancelled) return;

      setMasters({
        jobs: jobs || [],
        employees: staff.employees || [],
        incharge: staff.incharge || [],
        hods: staff.hods || [],
        departments: departments || [],
        shifts: shifts || [],
        contractors: contractors || [],
        contractTypes: contractTypes || [],
        ready: true,
      });
    });

    return () => { cancelled = true; };
  }, []);

  return <MastersContext.Provider value={masters}>{children}</MastersContext.Provider>;
};

export const useMasters = () => useContext(MastersContext);

/** "Firstname Lastname (CODE)" for an employee dropdown option. */
export const employeeLabel = (emp) =>
  `${[emp.first_name, emp.last_name].filter(Boolean).join(' ')} (${emp.employee_id})`;

/**
 * An employee picker keyed by user_id — what every *_by column stores.
 * Type-to-filter, because the list runs to hundreds of names.
 */
export const EmployeeSelect = ({ value, onChange, employees, placeholder = 'Search employee…' }) => (
  <SearchSelect
    value={value}
    onChange={onChange}
    options={employeeOptions(employees)}
    placeholder={placeholder}
  />
);

export default MastersContext;
